{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistemi",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatari i botit u fshi me sukses",
      "ERROR_DELETE": "Gabim gjatë fshirjes së avatarit të botit, provoni përsëri"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot name",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "What does this bot do?"
      },
      "BOT_CONFIG": {
        "ERROR": "Please enter your CSML bot configuration above.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Validate and save"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Select an agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Update",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "Successfully updated the agent bot.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Successfully disconnected the agent bot.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Botë sipas shtetit",
        "DESC": "Kjo kuti postare shërben disa shtete. Biseda shkon te boti i shtetit të saj: sipas dyqanit Kaufland, sipas tregut të porosisë Allegro, përndryshe sipas gjuhës në të cilën shkruan blerësi. Të gjitha bisedat e tjera shkojnë te boti i parazgjedhur më sipër.",
        "COUNTRY": "Zgjidhni një shtet",
        "BOT": "Zgjidhni një bot",
        "ADD": "Shto bot për një shtet",
        "REMOVE": "Hiq",
        "DEFAULT_REQUIRED": "Zgjidhni më parë botin e parazgjedhur. Boti i një shteti e zëvendëson atë vetëm për atë shtet.",
        "DISCONNECT_ALL": "Shkëput të gjithë botët"
      }
    },
    "ADD": {
      "TITLE": "Configure new bot",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Bot added successfully.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Detajet e botit",
        "URL": "URL-ja e webhook-ut"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Konfirmo fshirjen",
        "MESSAGE": "Jeni i sigurt që doni të fshini {name}?",
        "YES": "Po, fshi",
        "NO": "Jo, mbaj"
      },
      "SUBMIT": "Delete",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "DESCRIPTION": "Are you sure you want to delete this bot? This action is irreversible.",
      "API": {
        "SUCCESS_MESSAGE": "Bot deleted successfully.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Edit",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Bot updated successfully.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatari i botit"
      },
      "NAME": {
        "LABEL": "Emri i botit",
        "PLACEHOLDER": "Vendosni emrin e botit"
      },
      "DESCRIPTION": {
        "LABEL": "Përshkrimi",
        "PLACEHOLDER": "Çfarë bën ky bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL-ja e webhook-ut",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Emri i botit është i detyrueshëm",
        "URL": "URL-ja e webhook-ut është e detyrueshme",
        "VALID_URL": "Vendosni një URL të vlefshme që fillon me http:// ose https://"
      },
      "CANCEL": "Anulo",
      "CREATE": "Krijo botin",
      "UPDATE": "Përditëso botin"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
